import { render, staticRenderFns } from "./StrategySession.vue?vue&type=template&id=656b1c9e"
import script from "./StrategySession.vue?vue&type=script&lang=js"
export * from "./StrategySession.vue?vue&type=script&lang=js"
import style0 from "./StrategySession.vue?vue&type=style&index=0&id=656b1c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports